
import React,{useState,useRef,memo,useCallback,useEffect} from 'react'
import {getContentPath} from  'system/AssetManager'
import {animateParallax,getAnimationModel,animateIntersect,setInitialAnimIntersectState,setFinalAnimIntersectState} from './CanvasAnimator'
import Globals from 'system/Globals'
import gsap, {Power3} from 'gsap'
import InlineSVG from 'react-inlinesvg';
import {useInteraction} from './useInteraction'

function SVGButtonComponent(props){

    const [inline,setInline] = useState({})
    const [arInline,setArInline] = useState({})
    const [svgString,setSvgString] = useState(null)
    const [imgSrc, setImgSrc] = useState(null)
    const [pngOpacity, setPngOpacity] = useState(1)

    let bLoaded=false
    const refEle = useRef()
    const refArEle = useRef()
    const refArInnerEle = useRef();
    const refFormat = useRef()
    const refOrigOffset = useRef(0)
    const refAnimationModel = useRef({})

    const link = props.model.content ? props.model.content.module : null;

    const onClick = useInteraction({
        link,
        refEle,
        pageId: props.pageId,
        nid: props.nid,
        flatMenuItems: props.flatMenuItems,
        onScrollToEvent: props.onScrollToEvent,
        setCurrentPage: props.setCurrentPage,
        socket: props.socket,
        socketPrefs: props.socketPrefs
    })

    useEffect(()=>{
        if (refEle.current) {
            refOrigOffset.current=refEle.current.offsetLeft
        }

        if(refFormat.current && refFormat.current.animation && refFormat.current.animation.typeName){
            refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation)
            if(props.renderOnly===true){
                setFinalAnimIntersectState(refEle.current,refFormat.current.animation)
            }
        }

    },[inline])

    const onScroll = useCallback((scrollLeft,scale,pageWidth)=>{
        animateParallax(refEle.current,refAnimationModel.current,scrollLeft,pageWidth)
    },[props.model.animation,refEle])

    useEffect(() => {
        if (props.pageState === "animPage" && inline && refAnimationModel.current && refAnimationModel.current.animations) {
            animateIntersect(refEle.current,refAnimationModel.current)
        }
    }, [props, inline])

    const onIntersect = useCallback((evt,threshold)=>{
        if(evt.detail.isIntersecting )
        {
            if(evt.detail.intersectionRatio >=threshold)
                animateIntersect(refEle.current,refAnimationModel.current)
        }
        else if(evt.detail.intersectionRatio <=0.001)
            setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
    },[refEle])

    const onAnim = useCallback((evt,threshold)=>{
        if(evt)
        {
            animateIntersect(refEle.current,refAnimationModel.current)
        }
        else {
            setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
        }
    },[refEle])

    useEffect(()=>{

        refFormat.current = Globals.instance().getCanvasFormat(props.model.formats,props.format)

        let imgStyle ={position:'relative',transform: 'translateZ(0), perspective: 1000px', opacity: 0, 'width': '100%', 'height': '100%', 'cursor': 'pointer'};
        let arStyle = {position:'absolute',transform: 'translateZ(0), perspective: 1000px', opacity: 0, 'cursor': 'pointer'};

        if (refFormat.current) {
            if(refFormat.current.style && !props.pageBkg){
                let left = refFormat.current.style.left;
                let top =  refFormat.current.style.top;
                let width = refFormat.current.style.width;
                let objectFit = refFormat.current.style.objectFit;
                let opacity = refFormat.current.style.opacity;
                let imgOpacity = refFormat.current.style.opacity;
                let transform = refFormat.current.style.transform;
                let height = refFormat.current.style.height;

                imgStyle = Object.assign(imgStyle,{'opacity': imgOpacity})
                setPngOpacity(imgOpacity)
                arStyle = Object.assign(arStyle,{'left': left, 'top': top, 'width': width, 'height': height, 'objectFit': objectFit, 'opacity': opacity, 'transform': transform})
            } else {
                imgStyle = Object.assign(imgStyle,{'opacity': 1})
                arStyle = Object.assign(imgStyle,{'opacity': 1})
            }

            let f = refFormat.current.svg_markup;

            if (f) {
                const wMatch = f.match(/<svg[^>]*\swidth="(\d+(?:\.\d+)?)"/);
                const hMatch = f.match(/<svg[^>]*\sheight="(\d+(?:\.\d+)?)"/);

                if (wMatch && hMatch) {
                    f = f.replace(/viewBox="[^"]*"/, 'viewBox="0 0 ' + wMatch[1] + ' ' + hMatch[1] + '"');
                }

                if (f.match(/preserveAspectRatio="/)) {
                    f = f.replace(/preserveAspectRatio="[^"]*"/, 'preserveAspectRatio="xMinYMin slice"');
                } else {
                    f = f.replace(/<svg\s/, '<svg preserveAspectRatio="xMinYMin slice" ');
                }

                if (f.match(/matrix\([^)]*(?:Infinity|NaN)/)) {
                    const svgW = wMatch ? parseFloat(wMatch[1]) : 0;
                    const svgH = hMatch ? parseFloat(hMatch[1]) : 0;
                    f = f.replace(
                        /matrix\([^)]*(?:Infinity|NaN)[^)]*\)/g,
                        'translate(' + (svgW / 2) + ' ' + (svgH / 2) + ')'
                    );
                }

                f = f.replace(/<(line|path|rect|circle|ellipse|polygon|polyline)\s/g,
                    '<$1 vector-effect="non-scaling-stroke" ');
            }

            if (f) {
                setSvgString(f)
            } else if (refFormat.current.file) {
                setImgSrc(getContentPath(refFormat.current.file))
            }

            if(refFormat.current.animation){
                if(refFormat.current.animation.typeName==='parallax'){
                    props.setScrollCallback(onScroll,props.index)
                    imgStyle.willChange='transform'
                }
                else if(refFormat.current.animation.typeName==='page'){
                    props.onIntersect(onIntersect, props.index)
                    props.onAnim(onAnim, props.index)
                    imgStyle.willChange='transform, scale, opacity'
                }
            }
        }

        setInline(imgStyle)
        setArInline(arStyle);

        return ()=>{}
    },[])

    function onError(evt){
        console.error("SVGButton load error"+bLoaded, evt.target.src)
    }

    function onLoad(){
        if(!bLoaded){
            gsap.to(refArInnerEle.current, {opacity: 1, duration: 0.2})
            props.onLoad(props.index,refEle.current,props.model)
            bLoaded=true
            if(props.renderOnly===true){
                refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation)
                setFinalAnimIntersectState(refEle.current,refAnimationModel.current)
            }
        }
    }

    return (
        <span className="svgBox" style={arInline} ref={refArEle} onClick={onClick} id={refFormat.current && "component_dim_file_svg_" + refFormat.current.component} data-id={refFormat.current && refFormat.current.id} data-fileformat={refFormat.current && refFormat.current.file_format} data-opacity={arInline.opacity}>
            {refFormat.current && svgString && <span className="arBoxInner" ref={refEle} style={inline}><InlineSVG
            src={svgString}
            cacheRequests={true}
            width={"100%"}
            height={"100%"}
            onLoad={() => onLoad()}
            onError={(error) => console.log(error.message)}
            /></span>}
            {refFormat.current && imgSrc && <span className="arBoxInner" ref={refEle} style={inline}><img
            src={imgSrc}
            draggable="false"
            width={"100%"}
            height={"100%"}
            alt=""
            onLoad={() => onLoad()}
            onError={(evt) => onError(evt)}
            /></span>}
        </span>
    )

}

const SVGButton = memo(SVGButtonComponent, (prev,next)=>{  return prev.imgSrc === next.imgSrc })
export  {SVGButton}
